export const jobs = {
  home: {
    latestTitle: 'Dernières opportunités',
    viewAll: 'Voir plus'
  },
  listing: {
    title: 'Offres d\'Emploi',
    subtitle: 'Découvrez les meilleures opportunités de carrière',
    results: 'résultats',
    noResults: 'Aucune offre ne correspond à vos critères',
    noResultsDesc: 'Essayez de modifier vos filtres pour voir plus d\'offres',
    clearFilters: 'Effacer les filtres',
    loadMore: 'Charger plus d\'offres',
    filters: {
      title: 'Filtres',
      keywords: 'Mots-clés',
      keywordsPlaceholder: 'Poste, compétences...',
      location: 'Localisation',
      locationPlaceholder: 'Ville, région...',
      category: 'Catégorie',
      categoryAll: 'Toutes les catégories',
      contractType: 'Type de contrat',
      contractAll: 'Tous les types',
      search: 'Rechercher',
      reset: 'Réinitialiser'
    },
    categories: {
      it: 'Informatique & Tech',
      marketing: 'Marketing & Communication',
      sales: 'Ventes & Commerce',
      finance: 'Finance & Comptabilité',
      hr: 'Ressources Humaines',
      engineering: 'Ingénierie',
      healthcare: 'Santé',
      education: 'Éducation',
      logistics: 'Logistique',
      other: 'Autre'
    },
    contracts: {
      temps_plein: 'Temps plein',
      temps_partiel: 'Temps partiel',
      sur_appel: 'Sur appel',
      tele_travail: 'Télé travail',
      fin_de_semaine: 'Fin de semaine',
      stage: 'Stage',
      freelance: 'Freelance',
      alternance: 'Alternance'
    }
  },
  detail: {
    applyNow: 'Postuler maintenant',
    viewJob: 'Voir l\'offre',
    share: 'Partager',
    saved: 'Enregistré',
    save: 'Enregistrer',
    description: 'Description du poste',
    requirements: 'Profil recherché',
    benefits: 'Avantages',
    company: 'À propos de l\'entreprise',
    location: 'Localisation',
    contractType: 'Type de contrat',
    salary: 'Salaire',
    experience: 'Expérience',
    education: 'Formation',
    postedOn: 'Publié le',
    expiresOn: 'Expire le',
    similarJobs: 'Offres similaires',
    backToList: 'Retour aux offres'
  }
};